
exports.clinicalStatuses = {
  active: {
    code: 'active',
    display: 'Active',
    system: 'bcm',
    version: '1.0.0',
  },
  recurrence: {
    code: 'recurrence',
    display: 'Recurrence',
    system: 'bcm',
    version: '1.0.0',
  },
  relapse: {
    code: 'relapse',
    display: 'Relapse',
    system: 'bcm',
    version: '1.0.0',
  },
  inactive: {
    code: 'inactive',
    display: 'Inactive',
    system: 'bcm',
    version: '1.0.0',
  },
  remission: {
    code: 'remission',
    display: 'Remission',
    system: 'bcm',
    version: '1.0.0',
  },
  resolved: {
    code: 'resolved',
    display: 'Resolved',
    system: 'bcm',
    version: '1.0.0',
  },
};